import { NonNullableSettingConfig } from "./NonNullableSettingConfig";
import { AppKey } from "shared-ts-app-info";
import { User } from "shared-ts-utils-authentication";
import { LocalSettingsStorage } from "./storage/LocalSettingsStorage";
import { SettingKey } from "./SettingKeyDto";
import { SettingConfig } from "./SettingConfig";

export class UserSettings {
  readonly app: AppKey;
  readonly user: User | null;

  constructor(params: { app: AppKey; user: User | null }) {
    this.app = params.app;
    this.user = params.user;
  }

  read<Type>(name: string, config: NonNullableSettingConfig<Type>): Type {
    const key = SettingKey.from(name, this.app, this.user?.id);
    return LocalSettingsStorage.readValue(key, config as SettingConfig<Type>);
  }

  write<Type>(
    name: string,
    value: Type,
    config: NonNullableSettingConfig<Type>
  ) {
    const key = SettingKey.from(name, this.app, this.user?.id);
    return LocalSettingsStorage.writeValue(
      key,
      value,
      config as SettingConfig<Type>
    );
  }
}
